module.exports = __webpack_public_path__ + "static/media/nexus-icon.b6b1b6bf.png";